<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khách sạn' }}
                </div>
                <div class="">
                  <el-select
                    v-model="searchParams.hotelIds"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Danh mục' }}
                </div>
                <div class="">
                  <el-select
                    v-model="searchParams.subTransactionId"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(subTxn, index) in subTransactionOptions"
                      :key="index"
                      :value="subTxn.value"
                      :label="subTxn.label"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khoảng ngày' }}
                </div>
                <div class="">
                  <CalendarRange v-model="searchParams.date" mode="date" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Số hóa đơn' }}
                </div>
                <div class="">
                  <input
                    v-model="searchParams.invoiceNum"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Recode' }}
                </div>
                <div class="">
                  <input
                    v-model="searchParams.recode"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Người tạo' }}
                </div>
                <div class="">
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['code', 'name']"
                    :selected-index-field-value="searchParams.accountID"
                    :value="searchParams.accountID"
                    :rows="salePersonRows"
                    :columns="salePersonCols"
                    :dropdown-width="400"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectSalePerson"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          {{
                            `${selectedData?.code || ''} - ${
                              selectedData?.full_name || ''
                            }`
                          }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label" style="visibility: hidden">
                  {{ 'includeHUInPercentOcc' }}
                </div>
                <div
                  style="
                    background: #f0f0f5;
                    padding: 0 8px;
                    margin: 0;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    border-radius: 5px;
                  "
                >
                  <div class="checkbox-wrap">
                    <input
                      id="foc"
                      v-model="searchParams.foc"
                      type="checkbox"
                    />
                    <label for="foc" style="color: #606266; font-size: 14px">{{
                      'Hiển thị FOC'
                    }}</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Trạng thái thanh toán' }}
                </div>
                <div class="">
                  <el-select
                    v-model="searchParams.complete"
                    placeholder="Vui lòng chọn"
                  >
                    <el-option
                      v-for="item in isCompleteOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>

          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Số  phòng' }}
                </div>
                <div class="">
                  <input
                    v-model="searchParams.roomNum"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Nguồn khách' }}
                </div>
                <div class="">
                  <select-with-search-table
                    style="width: 100%"
                    :rows="sourceOptions"
                    :columns="columnsSource"
                    index-field="id"
                    :dropdown-width="400"
                    :is-remove-btn="true"
                    :selected-index-field-value="searchParams.sourceId"
                    :value="searchParams.sourceId"
                    @selectionChanged="onSelectRowSource"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      {{ selectedData?.code }}
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo doanh thu chi tiết` }}
              </span>
            </div>

            <DownloadBtn
              @exportExcel="exportExcel"
              @openNoteDialog="dialogNoteVisible = true"
            />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <template v-for="(rows, index) in rowss">
              <GridEnterprise
                :key="index"
                ref="agGrid"
                :columns="columns"
                :rows="rows"
                class="agGrid"
                :header-height="0"
                :group-default-expanded="0"
                style="height: auto !important"
                :suppress-row-click-selection="true"
                :suppress-row-transform="true"
              />
            </template>

            <!-- summarization -->
            <GridEnterprise
              ref="agGrid"
              :columns="columns"
              :rows="rowsAll"
              class="agGrid"
              :header-height="0"
              style="height: auto !important"
              :suppress-row-click-selection="true"
              :suppress-row-transform="true"
            />
            <!-- :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef" -->
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>- Ngày</li>
            <li>- Recode: mã đặt phòng cho khách lẻ, Mã đoàn cho khách đoàn</li>
            <li>- Nguồn: Hiển thị Nguồn chi tiết của đặt phòng</li>
            <li>- Số hóa đơn: hiển thị số hóa đơn</li>
            <li>- Người tạo: hiển thị học và tên tài khoản tạo giao dịch</li>
            <li>- Số phòng: hiển thị số phòng</li>
            <li>-NL: số lượng người lớn</li>
            <li>- TE: hiển thị số lượng trẻ em</li>
            <li>- TE &lt; 5t: hiển thị số lượng trẻ em &lt; 5 tuổi</li>
            <li>- Thành tiền: Giá dịch vụ sau khi giảm giá</li>
            <li>- Đã thanh toán = Cọc + Thanh toán thêm</li>
            <li>- Chưa thanh toán = Thành tiền - Đã thanh toán</li>
            <li>- Ghi chú:</li>
            <li>+ Nếu là FOC: hiển thị :FOC</li>
            <li>+ Nếu không phải FOC : để trống</li>
            <li>
              '+-' : Cho phép hiển thị tổng của từng danh mục hoặc hiển thị chi
              tiết theo từng ngày từng hàng
            </li>
            <li>- Hàng dọc: hiển thị từng danh mục</li>
            <li>
              - hiện từng ngày : có các dịch vụ ..... ngày 2: có các dịch vụ
            </li>
            <li>
              - Danh Mục: Hiển thị các danh mục phát sinh giao dịch trong khoảng
              thời gian tìm kiếm
            </li>
            <li>- Tổng: Hiển thị tông của từng cột của từng Danh mục</li>
            <li>- Tông cộng: hiển thị tổng cộng của tất cả các danh mục</li>
            <li>
              - Tổng: hiển thị tổng cộng của tất cả các danh mục trong khoảng
              thời gian tìm kiếm
            </li>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
import DownloadBtn from './components/DownloadBtn.vue'
import NoteDialog from './components/NoteDialog.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import { DEFAULT_GRID_ROW_HEIGHT } from '@/constant'

import { getAllHotel } from '@/api/hotel'
import { getAccount } from '@/api/reception/common'
import { getSourceApi } from '@/api/Statistics/source'
import { getSubServiceTransaction } from '@/api/report_service/datntReport'
import {
  getDetailRevenueReport,
  getDetailRevenueReportExcel
} from '@/api/report_service/datntReport'
import { formatVND } from '@/utils/commonUtils'

const cellClassRules = {
  headerRow: params => params.data?.row_class === 'headerRow',
  groupRow: params => params.data?.row_class === 'groupRow',
  sumRow: params => params.data?.row_class === 'sumRow',
  totalRow: params => params.data?.row_class === 'totalRow'
}

export default {
  components: { DownloadBtn, NoteDialog, CalendarRange },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      searchParams: {
        subTransactionId: null,
        recode: null,
        foc: null,
        complete: null,
        roomNum: null,
        sourceId: null,
        accountID: null,
        hotelIds: [],
        invoiceNum: null,

        date: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD')
      },
      defaultSearchParams: {
        subTransactionId: null,
        recode: null,
        foc: null,
        complete: null,
        roomNum: null,
        sourceId: null,
        accountID: null,
        hotelIds: [],
        invoiceNum: null,

        date: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD')
      },

      // data for search
      hotelList: [],
      isCompleteOptions: [
        {
          label: 'Chọn tất cả',
          value: null
        },
        {
          label: 'Đã thanh toán hết',
          value: true
        },
        {
          label: 'Chưa thanh toán hết',
          value: false
        }
      ],
      salePersonRows: [],
      salePersonCols: [
        {
          headerName: 'Tên',
          field: 'full_name',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Code',
          field: 'code',
          // tooltipFiled: 'desc',
          flex: 1
        }
      ],
      sourceOptions: [],
      columnsSource: [
        {
          headerName: 'Mã nguồn',
          field: 'code',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Mô tả',
          field: 'desc',
          // tooltipFiled: 'desc',
          flex: 1
        }
      ],
      subTransactionOptions: [
        {
          label: 'Chọn tất cả',
          value: null
        }
      ],

      // grid
      rowsAll: [],
      rowss: [],

      // dialog
      dialogNoteVisible: false
    }
  },

  computed: {
    columns() {
      return [
        { field: 'group_name', rowGroup: true, hide: true },
        // {
        //   field: 'date',
        //   width: 300,
        //   rowSpan: params => {
        //     if (params.data?.row_class === 'firstRow') {
        //       return params.data?.count_rows
        //     } else {
        //       return 1
        //     }
        //   },
        //   cellStyle: params => {
        //     if (
        //       params.data?.row_class === 'firstRow' &&
        //       params.data?.count_rows > 1
        //     ) {
        //       return {
        //         backgroundColor: 'white !important',
        //         top: 0,
        //         borderBottom: `1px solid rgba(189, 195, 199, 0.58)`,
        //         height: `calc(${params.data?.count_rows} * ${DEFAULT_GRID_ROW_HEIGHT}px) !important`
        //       }
        //     }
        //     return null
        //   },
        //   cellClassRules: {
        //     headerRow: params => params.data?.row_class === 'headerRow',
        //     groupRow: params => params.data?.row_class === 'groupRow',
        //     sumRow: params => params.data?.row_class === 'sumRow'
        //   }
        // },
        {
          field: 'recode',
          cellClassRules: cellClassRules,
          rowSpan: params => window.rowSpan(params),
          cellStyle: params => window.cellStyle(params),
          minWidth: 120,
          maxWidth: 180
        },
        {
          field: 'source',
          cellClassRules: cellClassRules,
          minWidth: 100,
          flex: 1,

          rowSpan: params => window.rowSpan(params),
          cellStyle: params => window.cellStyle(params)
        },
        {
          field: 'create_user',
          cellClassRules: cellClassRules,
          // rowSpan: params => window.rowSpan(params),
          // cellStyle: params => window.cellStyle(params),
          minWidth: 100
        },
        {
          field: 'invoice_num',
          cellClassRules: cellClassRules,
          minWidth: 100
        },
        {
          field: 'room_num',
          cellClassRules: cellClassRules,
          minWidth: 120,
          maxWidth: 130
        },
        {
          field: 'adult',
          cellClassRules: cellClassRules,
          minWidth: 70,
          maxWidth: 80
        },
        {
          field: 'child',
          cellClassRules: cellClassRules,
          minWidth: 70,
          maxWidth: 80
        },
        {
          field: 'infant',
          cellClassRules: cellClassRules,
          minWidth: 80,
          maxWidth: 100
        },
        {
          field: 'money',
          cellClassRules: {
            ...cellClassRules,
            'ag-cell-right': params => true
          },
          minWidth: 100
          // cellRenderer: params => formatVND(params.data.money, null)
        },
        {
          field: 'paid',
          cellClassRules: {
            ...cellClassRules,
            'ag-cell-right': params => true
          },
          minWidth: 100
        },
        {
          field: 'unpaid',
          cellClassRules: {
            ...cellClassRules,
            'ag-cell-right': params => true
          },
          minWidth: 100
        },
        {
          field: 'note',
          cellClassRules: cellClassRules,
          minWidth: 100
        }
      ]
    }
  },

  async mounted() {
    window.rowSpan = params => {
      if (params.data?.rowSpan) {
        return params.data?.rowSpan
      } else {
        return 1
      }
    }
    window.cellStyle = params => {
      if (params.data?.rowSpan) {
        return {
          backgroundColor: 'white !important',
          top: 0,
          borderBottom: `1px solid rgba(189, 195, 199, 0.58)`,
          borderRight: `1px solid rgba(189, 195, 199, 0.58)`,
          height: `calc(${params.data?.rowSpan} * ${DEFAULT_GRID_ROW_HEIGHT}px) !important`
          // display: 'flex',
          // alignItems: 'center'
        }
      }
      return null
    }
    // window.cellClassRules = {
    //   headerRow: params => params.data?.row_class === 'headerRow',
    //   groupRow: params => params.data?.row_class === 'groupRow',
    //   sumRow: params => params.data?.row_class === 'sumRow'
    // }

    // normal data
    await this.getListHotel()
    await this.getListSalePerson()
    await this.getListSource()
    await this.getListSubServiceTransaction()

    await this.fnGetDetailRevenueReport()
  },
  methods: {
    // helper:
    convertRowSpan(arr, field, fieldSpan, start, end) {
      let nameOut
      for (let i = start; i < end; i++) {
        let rowSpan = 0
        const name = arr[i][field]
        for (let j = start; j < end; j++) {
          if (arr[j][field] === name) {
            rowSpan++
          }
        }
        if (name === arr[i][field] && name !== nameOut) {
          arr[i][fieldSpan] = rowSpan
          nameOut = name
        }
      }
    },

    onSearch() {
      this.fnGetDetailRevenueReport()
    },
    onResetSearch() {
      this.searchParams = { ...this.defaultSearchParams }
      this.fnGetDetailRevenueReport()
    },

    // chon bo phan Le tan
    onSelectSalePerson(selected) {
      this.searchParams.accountID = selected?.id
    },
    onSelectRowSource(val) {
      this.searchParams.sourceId = val.id
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },
    exportExcel() {
      const query = {
        subTransactionId: this.searchParams.subTransactionId,
        recode: this.searchParams.recode,
        foc: this.searchParams.foc,
        complete: this.searchParams.complete,
        roomNum: this.searchParams.roomNum,
        sourceId: this.searchParams.sourceId,
        accountID: this.searchParams.accountID,
        hotelIds: this.searchParams.hotelIds,
        invoiceNum: this.searchParams.invoiceNum,
        dateFrom: this.searchParams.date.start,
        dateTo: this.searchParams.date.end
      }
      getDetailRevenueReportExcel(query).then(res => {
        if (res) {
          const date = this.$moment().format('DD-MM-YYYY')
          const href = URL.createObjectURL(res)
          // create "a" HTML element with href to file & click
          const link = document.createElement('a')
          link.href = href
          link.setAttribute(
            'download',
            'doanh_thu_chi_tiet_report_' + date + '.xlsx'
            // res.headers['content-disposition'].split('filename=')[1],
          ) // or any other extension
          document.body.appendChild(link)
          link.click()
          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link)
          URL.revokeObjectURL(href)
        } else {
          throw new Error(res)
        }
      })
    },

    // handle api call
    async fnGetDetailRevenueReport() {
      try {
        const query = {
          subTransactionId: this.searchParams.subTransactionId,
          recode: this.searchParams.recode,
          foc: this.searchParams.foc,
          complete: this.searchParams.complete,
          roomNum: this.searchParams.roomNum,
          sourceId: this.searchParams.sourceId,
          accountID: this.searchParams.accountID,
          hotelIds: this.searchParams.hotelIds,
          invoiceNum: this.searchParams.invoiceNum,
          dateFrom: this.searchParams.date.start,
          dateTo: this.searchParams.date.end
        }

        const res = await getDetailRevenueReport(query)
        const sumRow = res.data.pop()

        this.rowss = res.data.map(rows => {
          rows = rows.map((row, index) => {
            // console.log(row, index)
            if (row?.is_full_width_row) {
              return {
                ...row,
                isFullWidthRow: true,
                name: `Ngày ${row.date}`
              }
            }
            if (row?.total_adult !== undefined) {
              return {
                ...row,
                room_num: row.row_class === 'groupRow' ? 'Tổng cộng' : 'Tổng',
                adult: row.total_adult,
                child: row.total_child,
                infant: row.total_infant,
                money: formatVND(row.total_price, null),
                paid: formatVND(row.total_paid, null),
                unpaid: formatVND(row.total_unpaid, null),
                row_class: row.row_class || 'totalRow'
              }
            }
            if (row?.row_class == null || row?.row_class === 'firstRow') {
              if (row?.row_class === 'firstRow' && row?.count_rows > 1) {
                this.convertRowSpan(
                  rows,
                  'recode',
                  'rowSpan',
                  index,
                  index + row?.count_rows
                )
              }
              return {
                ...row,
                money: formatVND(row.price, null),
                paid: formatVND(row.paid, null),
                unpaid: formatVND(row.unpaid, null)
              }
            }

            return row
          })
          return rows
        })

        console.log(this.rowss)

        this.rowsAll = [
          {
            room_num: 'Tổng tất cả',
            adult: sumRow.total_adult,
            child: sumRow.total_child,
            infant: sumRow.total_infant,
            money: formatVND(sumRow.total_price, null),
            paid: formatVND(sumRow.total_paid, null),
            unpaid: formatVND(sumRow.total_unpaid, null),
            row_class: 'sumRow'
          }
        ]
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        //
      }
    },

    async getListSubServiceTransaction() {
      const res = await getSubServiceTransaction()
      res.data.forEach(item => {
        this.subTransactionOptions.push({
          label: item.code,
          value: item.id
        })
      })
    },
    async getListSalePerson() {
      // Le tan
      const res = await getAccount({ department: 'FO' })
      this.salePersonRows = res.data.map(item => {
        return {
          id: item.account.id,
          code: item.account.code,
          full_name: item.account.full_name
        }
      })
    },
    async getListSource() {
      const data = await getSourceApi({ isActive: 1 })
      this.sourceOptions = data.data
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    }
  }
}
</script>

<style lang="scss">
.headerRow,
.headerRow:hover {
  background-color: #357456 !important;
  color: white;
  font-weight: bold;
}
.groupRow,
.groupRow:hover {
  background-color: #e7f6e5 !important;
  font-weight: bold;
}
.sumRow,
.sumRow:hover {
  background-color: #317228 !important;
  color: white;
  font-weight: bold;
}
.totalRow,
.totalRow:hover {
  background-color: #e7f6e5 !important;

  .ag-cell {
    background-color: #e7f6e5 !important;
  }
}
</style>
